import AreYouSureDelete from '@app/components/AreYouSureDelete';
import ImageDialog from '@app/components/ImageDialog';
import ProductFormPage from '@app/components/ProductFormPage';

import { useCreateProductLogic } from './useCreateProductLogic';
import { CreateProductState, ICreateProductFormData } from './types';

const CreateProduct = () => {
  const {
    methods,
    isSuccess,
    previews,
    isViewImageModalOpen,
    isButtonLoading,
    imageUrl,
    isDeleteModalOpen,
    largeImageMessage,
    setState,
    onSubmit,
    handleDeleteImage,
    onChangeUpload,
  } = useCreateProductLogic();

  return (
    <>
      <ProductFormPage<ICreateProductFormData, CreateProductState>
        title="Create Product"
        submitLabel="Create"
        submittingLabel="Creating..."
        methods={methods}
        previews={previews}
        setState={setState}
        isSubmitting={isButtonLoading}
        isSuccess={isSuccess}
        largeImageMessage={largeImageMessage}
        onSubmit={onSubmit}
        onChangeUpload={onChangeUpload}
      />
      <ImageDialog
        url={imageUrl}
        isOpen={isViewImageModalOpen}
        onClose={() => {
          setState((prev) => ({ ...prev, isViewImageModalOpen: false, imageUrl: '' }))
        }}
      />
      <AreYouSureDelete
        open={isDeleteModalOpen}
        onClose={() => {
          setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
        }}
        onDelete={() => handleDeleteImage(imageUrl)}
      />
    </>
  );
};

export default CreateProduct;
